import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import { useHistory, useParams } from "react-router-dom";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

function LocationView() {
  const { id } = useParams();
  const [locationData, setLocationData] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Locations/GetLocationById?id=${id}`
        );
        const data = await response.json();
        setLocationData(data);
      } catch (error) {
        console.error("Failed to fetch location data:", error);
      }
    };

    fetchLocationData();
  }, [id]);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: null, // "YOUR_GOOGLE_MAPS_API_KEY"
  });

  if (!locationData) {
    return <div>Loading...</div>;
  }

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  const { title, fullAddress, addressDescription, latitude, longitude } =
    locationData;

  return (
    <>
      <Navbar />
      <div className="min-h-content-minvh">
        <div className="container">
          <div className="flex justify-between items-center mt-4">
            <h1 className="text-2xl font-bold">Location Details</h1>
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
              type="button"
              onClick={() => history.goBack()}
            >
              <i
                className="fa fa-arrow-circle-left mr-1"
                title="Go To Documents Library"
              ></i>
              Go Back
            </button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-6 xl:grid-cols-10 gap-4 mt-4">
            <div className="col-span-2">
              <b>Title:</b> {title}
            </div>
            <div className="col-span-2">
              <b>Address:</b> {fullAddress}
            </div>
            <div className="col-span-2">
              <b>Description:</b> {addressDescription}
            </div>
            <div className="col-span-2">
              <b>Latitude:</b> {latitude}
            </div>
            <div className="col-span-2">
              <b>Longitude:</b> {longitude}
            </div>
          </div>
          <div className="shadow-md">
            <div style={{ height: "400px", width: "100%", marginTop: "20px" }}>
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "100%" }}
                center={{ lat: Number(latitude), lng: Number(longitude) }}
                className="rounded-sm"
                zoom={15}
                options={{
                  disableDefaultUI: false,
                  scrollwheel: true,
                  gestureHandling: "greedy",
                }}
              >
                <Marker
                  position={{ lat: Number(latitude), lng: Number(longitude) }}
                  title="You are here"
                  icon={{
                    url: "https://img.icons8.com/color/48/000000/marker.png",
                    scaledSize: new window.google.maps.Size(40, 40),
                  }}
                />
              </GoogleMap>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LocationView;
